
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApidataService } from 'src/app/apidata.service';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import * as $ from "jquery";
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
 
	constructor() {
  
	}
  
  
	ngOnInit() {
	}

	toggle() {
		$("#sidebar").toggleClass("active");
	  }
  }